/**
 * Created by Viacheslav on 2026-01-25
 * Global map of nodes to their attached script components
 * Components are automatically cleaned up when node is destroyed
 */

const ComponentMap = {
    _map: new Map(),

    attach: function (node, component) {
        if (!this._map.has(node)) {
            this._map.set(node, []);
            addCleaner(node, () => {
                this.detachAll(node);
            });
        }

        if (this.get(node, component.constructor)) {
            cleverapps.throwAsync(`Node already has component ${component.constructor.name}`);
        }

        this._map.get(node).push(component);

        component.node = node;

        this.callHook(component, "onAttach");

        return component;
    },

    detach: function (node, ComponentClass) {
        const components = this._map.get(node);
        if (components) {
            const index = components.findIndex((comp) => comp instanceof ComponentClass);
            if (index !== -1) {
                const comp = components[index];
                components.splice(index, 1);

                return comp;
            }
        }
    },

    detachAll: function (node) {
        const components = this._map.get(node);
        if (!components) {
            return;
        }

        this.callHooks(node, "onDestroy");

        this._map.delete(node);
    },

    get: function (node, ComponentClass) {
        const components = this._map.get(node);
        if (!components) {
            return undefined;
        }
        return components.find((c) => c instanceof ComponentClass);
    },

    getByName: function (node, componentName) {
        const components = this._map.get(node);
        if (!components) {
            return undefined;
        }
        return components.find((c) => c.constructor.name === componentName);
    },

    callHook: function (component, hookName, ...args) {
        if (typeof component[hookName] === "function") {
            return component[hookName](...args);
        }
    },

    callHooks: function (node, hookName, ...args) {
        const components = this._map.get(node);
        if (components) {
            for (let i = 0; i < components.length; ++i) {
                this.callHook(components[i], hookName, ...args);
            }
        }
    },

    callFirstHook: function (node, hookName, ...args) {
        const components = this._map.get(node);
        if (components) {
            for (let i = components.length - 1; i >= 0; --i) {
                if (this.callHook(components[i], hookName, ...args)) {
                    break;
                }
            }
        }
    }
};
